import React, {Component, useState, useEffect} from 'react'
import {Redirect, Link} from 'react-router-dom';
import UserService from "../../API/user/UserService"
import {Card, Input, Button} from 'antd'
import PropTypes from 'prop-types';

import "./Login.css"
import Footer3 from '../../components/layout/Footer3';
import Navbar from '../../components/layout/Navbar';

const LoginInner = (props) => {
    const [toast, setToast] = useState(null);

    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 5000);
        return () => clearTimeout(timer);
    }, [toast]);

    return (
        <>
            <Navbar />
            <Login {...props} setToast={setToast} />
            {toast && (
                <div className="toast-notification-wrapper">
                    <div className={`toast-notification ${toast.type || 'error'}`}>
                        <div>
                            {toast.title && (
                                <div className="toast-notification-title">{toast.title}</div>
                            )}
                            <div>{toast.message}</div>
                        </div>
                        <button
                            type="button"
                            className="toast-notification-close"
                            onClick={() => setToast(null)}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
            <Footer3 />
        </>
    );
};

class Login extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            email: '',
            password: '',
            isLoading: false,
            feedback: null,
            redirect: false,
            token: ''
        }
    }
    
    
    static contextTypes = {
        encrypt: PropTypes.func.isRequired,
        decrypt: PropTypes.func.isRequired,
    }

    submit = () => {
        this.setState({isLoading: true})
        if (this.state.email === '' || this.state.password === '') {
            this.setState({isLoading: false, feedback: "please include all fields"})
            this.props.setToast && this.props.setToast({
                type: 'error',
                title: 'Missing information',
                message: 'Please fill in both email and password.'
            });
        } else {
            UserService.signIn({
                email: this.state.email,
                password: this.state.password,
            })
                .then((resp) => {
                    this.setState({isLoading: false, feedback: ""})
                    const response = JSON.stringify(resp.data);
                    localStorage.setItem('UserData', response);
                    this.props.setToast && this.props.setToast({
                        type: 'success',
                        title: 'Login successful',
                        message: 'Redirecting to your consent dashboard...'
                    });
                    window.location.href = "/"

                })
                .catch((err) => {
                    console.error('Login error:', err?.response?.data || err);

                    const status = err?.response?.status;
                    const backendMsg = err?.response?.data?.message;
                    let msg;

                    if (status === 400 || status === 401) {
                        msg = 'Invalid email or password. Please try again.';
                    } else if (status === 404) {
                        msg = 'Account not found for this email. Please check your details or register.';
                    } else if (typeof backendMsg === 'string' && backendMsg.length < 200) {
                        msg = backendMsg;
                    } else {
                        msg = 'Failed to login. Please try again later.';
                    }

                    this.setState({isLoading: false, feedback: msg});
                    this.props.setToast && this.props.setToast({
                        type: 'error',
                        title: 'Login failed',
                        message: msg
                    });
                });
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

   
    render() {
        return (
            <div className='auth-page'>
                <div className='auth-card-wrapper'>
                    <Card className='auth-card'>
                        <h1 className='auth-title'>Welcome Back!</h1>
                        <p className='auth-subtitle'>
                            Enter your email address and password to access your account
                        </p>

                        <div className='auth-form-group'>
                            <label className='auth-label'>Email address or Username</label>
                            <Input
                                name="email"
                                onChange={(e) => this.handleChange(e)}
                                placeholder="Enter your email"
                                className='auth-input'
                            />
                        </div>

                        <div className='auth-form-group'>
                            <label className='auth-label'>Password</label>
                            <Input
                                name="password"
                                onChange={(e) => this.handleChange(e)}
                                placeholder="Enter your password"
                                className='auth-input'
                                type="password"
                            />
                            <div className='auth-forgot-link'>
                                <Link to="/reset">Forgot Password?</Link>
                            </div>
                        </div>

                        <Button
                            onClick={this.submit}
                            type="primary"
                            className='auth-btn'
                        >
                            {this.state.isLoading ? (
                                <div className="lds-facebook"><div></div><div></div><div></div></div>
                            ) : (
                                <>Login <span>&#8594;</span></>
                            )}
                        </Button>

                        {this.state.feedback && (
                            <p className='auth-feedback'>{this.state.feedback}</p>
                        )}

                        <div className='auth-footer'>
                            Don't have an account? <Link to="/register">Sign Up</Link>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
}


export default LoginInner;
